import React, { useContext } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import InfoButtonWithPopover from "./InfoButtonWithPopover";
import { AuthContext } from '../context/authContext';

const TablaInicio = ({ data, isLoading,
    //setRegistro,
    onEditarRegistro,
    setNewEditandoId,  handlePreviewClick, arrayEditando, handleIsEditing,
    showRendicion, onLiberarEdicion, onSoftDelete,
    showValoracion, onValorar
}) => { //rowInforme
    console.log("Datos en TablaInicio:", data); // Verifica que los datos lleguen
    console.log("ARRAY EDITANDO", arrayEditando)
    const {user, role} = useContext(AuthContext)
    console.log("USER", user)
    if (isLoading) {
        return (
            <div className="flex justify-center items-center p-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (data.length === 0) {
        return (
            <div className="text-center py-8 text-gray-500">
                No se encontraron registros que coincidan con los filtros seleccionados.
            </div>
        );
    }

    // Función para formatear fechas
    const formatearFecha = (fecha) => {
        if (!fecha) return 'N/A';
        try {
            // Asegurarse de que la fecha sea un objeto Date válido
            const fechaObj = new Date(fecha);
            if (isNaN(fechaObj.getTime())) return 'Fecha inválida';
            
            return format(fechaObj, "dd/MM/yyyy", { locale: es });
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return 'N/A';
        }
    };

    const handleRowClick = (row, isEditing) => {
        console.log("ROW CLICKED", row)
        console.log("que recibe en IS EDITING", isEditing) //siempre es tru
        //if isEditing status es 'edit'
        /*let status;
        if(isEditing===true){
            status = 'edit'
        }else{
            status = 'edit'
        }*/
        onEditarRegistro(row)// cambiamos ---->setRegistro(row)
        setNewEditandoId(row.id_partido_obra)
        handleIsEditing(isEditing)
    }

    // Función para verificar si una fila está siendo editada
    const isRowBeingEdited = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/

         // Asegurarse de que arrayEditando sea un array
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isEditing = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando'; //&& userEditClean !== user 
        });
        
        //console.log("IS EDITING", isEditing)
        return isEditing;
        //return arrayEditando[obraId]?.length > 0;
    };

    //funcion para verificar si ademas es 'solo_lectura'
    const isRowBeingReadOnly = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/

         // Asegurarse de que arrayEditando sea un array
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isReadOnly = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, ''); //HACE falta??
            return objeto.id_edit === obraId && userEditClean !== user && objeto.status === 'solo_lectura';
        });
        
        //console.log("IS EDITING", isEditing)
        return isReadOnly;
        //return arrayEditando[obraId]?.length > 0;
    };

    // Función para obtener el texto del tooltip - 
    //NOTA: resolver primero como quitar usuarios del arrayEditando para que no muestre  Javier y Datos
    
    const getEditingTooltip = (obraId) => {
        try {
            const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];

            //Verificar si hay id_edit con status 'editando' y 'solo_lectura' y devolver el user_edit
            const editando = safeArray.find(item => item && item.id_edit === obraId && item.status === 'editando');
            const soloLectura = safeArray.find(item => item && item.id_edit === obraId && item.status === 'solo_lectura');

            if (editando && soloLectura) {
                return `Editando usuario: ${editando.user_edit} - Solo lectura: ${soloLectura.user_edit}`;
            } else if (soloLectura) {
                return `Solo lectura: ${soloLectura.user_edit}`;
            } else if (editando){
                return `Editando usuario: ${editando.user_edit}`;
            }
           
        } catch (error) {
            console.error('Error en getEditingTooltip:', error);
            return '';
        }
    };

    return (
        <div className="shadow overflow-x-scroll overflow-y-auto max-h-[calc(100vh-340px)] border-b border-gray-200 dark:border-gray-700 sm:rounded-lg tabla-inicio-scroll">
            <style>{`
                .tabla-inicio-scroll::-webkit-scrollbar {
                    height: 8px;
                    width: 8px;
                }
                .tabla-inicio-scroll::-webkit-scrollbar-track {
                    background: transparent;
                }
                .tabla-inicio-scroll::-webkit-scrollbar-thumb {
                    background: rgba(100,116,139,0.5);
                    border-radius: 9999px;
                }
                .tabla-inicio-scroll::-webkit-scrollbar-track:vertical,
                .tabla-inicio-scroll::-webkit-scrollbar-thumb:vertical,
                .tabla-inicio-scroll::-webkit-scrollbar-corner {
                    display: none;
                }
            `}</style>
            <table className="min-w-[1500px] divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            ID
                        </th>
                        {role === 'admin' && (
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                Ver.
                            </th>
                        )}
                        {role === 'admin' && (
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                Ben.
                            </th>
                        )}
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Exp. proyecto
                        </th>
                        {showRendicion && (
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                Exp. rendición
                            </th>
                        )}
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Partido
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Nombre proyecto / Alias
                        </th>
                        {/*<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Expediente
                        </th>*/}
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Estado
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Programa
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Tipo subsidio
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Ver informe
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                            Acción
                        </th>
                        {showValoracion && (
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                Valoración
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {data.map((item, index) => {
                        const isEditing = isRowBeingEdited(item.id_partido_obra);
                        console.log("IS EDITING", index, isEditing)

                        //si tiene status solo_lectura crear una constante isReadOnly
                        const isReadOnly = isRowBeingReadOnly(item.id_partido_obra);
                        //console.log("IS ReadOnly", index, isEditing)
                        const editingTooltip = getEditingTooltip(item.id_partido_obra);

                        let expediente;
                        //const Si  esiste en item.array_obras_expediente donde objeto_o sea Proyecto
                        if (item.array_obras_expediente && item.array_obras_expediente.some(obj => obj && obj.objeto_o === 'Proyecto')) {
                            expediente = item.array_obras_expediente.find(obj => obj && obj.objeto_o === 'Proyecto');
                            console.log("EXPEDIENTE", expediente)
                        } else {
                            expediente = 'N/A';
                        }

                        let expedienteRendicion;
                        if (item.array_obras_expediente && item.array_obras_expediente.some(obj => obj && obj.objeto_o === 'Rendición')) {
                            expedienteRendicion = item.array_obras_expediente.find(obj => obj && obj.objeto_o === 'Rendición');
                        } else {
                            expedienteRendicion = null;
                        }

                        return (
                            <tr
                                key={item.id || index}
                                //className="hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors duration-150"
                                // Agregar manejador de clic si es necesario
                                //un estilo por defecto, un estilo para cuando se edita, un estilo solo lectura y un estilo para cuando se edita y se lee
                                className={`hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors duration-150 ${(isEditing === true && isReadOnly === true)
                                        ? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
                                        : ''
                                    } ${(isReadOnly === true && isEditing === false)
                                        ? 'hover:bg-yellow-200 bg-yellow-200 dark:hover:bg-yellow-200/20 dark:bg-yellow-200/20 dark:border-l-4 dark:border-l-yellow-200'
                                        : ''
                                    } ${(isEditing === true && isReadOnly === false)
                                        ? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
                                        : ''
                                    }`}
                                title={editingTooltip} //NO USAR POR AHORA
                                onDoubleClick={() => handleRowClick(item, isEditing)}
                            >
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {item.id_partido_obra || 'N/A'}
                                </td>
                                {role === 'admin' && (
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                        {item.version ?? 'N/A'}
                                    </td>
                                )}
                                {role === 'admin' && (
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                        {item.beneficiarios_reales ?? 0}
                                    </td>
                                )}
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {expediente.expediente_o || 'N/A'}
                                </td>
                                {showRendicion && (
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {expedienteRendicion ? expedienteRendicion.expediente_o : 'N/A'}
                                    </td>
                                )}
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {item.partido_nombre || 'N/A'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900 dark:text-white">
                                        {item.nombre_obra || 'N/A'}
                                    </div>
                                    <div className="text-sm text-gray-500 dark:text-gray-400">
                                        {item.localidad || ''}
                                    </div>
                                </td>
                                {/*<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                {item.expediente || 'N/A'}
                            </td>*/}
                                {/*<td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                                    ${item.estado === 'Finalizado' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 
                                      item.estado === 'En Progreso' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' :
                                      item.estado === 'Pendiente' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                                      'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'}`}>
                                    {item.estado || 'Sin estado'}
                                </span>
                            </td>*/}
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                    {item.estado || 'N/A'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                    {item.programa_lineamiento || 'N/A'}
                                </td>
                                {/*<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                {formatearFecha(item.fecha_inicio)}
                            </td>*/}
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                    {item.tipo_subsidio || 'N/A'}
                                </td>
                                {/*
                            MANTENER para otros casos: barra % avance
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                    <div 
                                        className="bg-blue-600 h-2.5 rounded-full" 
                                        style={{ width: `${item.avance || 0}%` }}
                                    ></div>
                                </div>
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                    {item.avance || 0}%
                                </span>
                            </td>
                            */}
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                    {/*<button onClick={() => rowInforme(item)}>
                                    Informe
                                </button>*/}
                                    <button onClick={() => handlePreviewClick(item)}>
                                        Previsualizar
                                    </button>
                                    <InfoButtonWithPopover infoText="EN DESARROLLO." />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                    {role === 'admin' && (isEditing || isReadOnly) && (
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (window.confirm(`¿Liberar bloqueo de ${item.id_partido_obra}?\n${editingTooltip ? 'Estado: ' + editingTooltip : ''}\n\nEsto permitirá que otros usuarios editen el registro.\nAsegurate de que nadie está editando activamente antes de continuar.`)) {
                                                    onLiberarEdicion?.(item.id_partido_obra);
                                                }
                                            }}
                                            className="text-red-600 hover:text-red-800 hover:underline text-xs font-medium"
                                            title="Liberar bloqueo de edición"
                                        >
                                            Liberar
                                        </button>
                                    )}
                                    {role === 'admin' && (
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (window.confirm(`¿Dar de baja la obra ${item.id_partido_obra}?\n\nEsto marcará el registro como inactivo. Se puede restaurar desde el historial.`)) {
                                                    onSoftDelete?.(item.id_partido_obra);
                                                }
                                            }}
                                            className="text-red-600 hover:text-red-800 hover:underline text-xs font-medium ml-2"
                                            title="Dar de baja obra"
                                        >
                                            Borrar
                                        </button>
                                    )}
                                </td>
                                {showValoracion && role === 'admin' && (
                                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                                        <div className="flex items-center gap-1">
                                            <button
                                                type="button"
                                                onClick={(e) => { e.stopPropagation(); onValorar?.(item.id_partido_obra, 1); }}
                                                className="px-2 py-1 text-sm rounded-md hover:bg-green-100 hover:text-green-700 dark:hover:bg-green-900/40 dark:hover:text-green-400"
                                                title="Resultado útil"
                                            >
                                                👍
                                            </button>
                                            <button
                                                type="button"
                                                onClick={(e) => { e.stopPropagation(); onValorar?.(item.id_partido_obra, -1); }}
                                                className="px-2 py-1 text-sm rounded-md hover:bg-red-100 hover:text-red-700 dark:hover:bg-red-900/40 dark:hover:text-red-400"
                                                title="Resultado no esperado"
                                            >
                                                👎
                                            </button>
                                        </div>
                                    </td>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default TablaInicio;
